module.exports = __webpack_public_path__ + "img/yahoo-finance.fd5b2683.webp";